import React from 'react';
import PropTypes from 'prop-types';

class MathWorkingRowsContainer extends React.Component {
    static propTypes = {
        mathRows: PropTypes.array.isRequired,
    };

    render() {
        return (
            <div>{this.props.mathRows}</div>
        );
    }
}

export default MathWorkingRowsContainer;
